/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA;
 */

import { get, writable } from 'svelte/store';
import { getAcsEvents } from '@/services/acsEventsService';

const DEFAULT_PAGE_SIZE = 20;

const initialState = {
    items: [],
    totalResults: 0,
    lastId: [],
    pageSize: DEFAULT_PAGE_SIZE,
    pageNum: 0,
    sortOrder: 'DESC',
    isLoading: false,
    error: null,
    hasLoaded: false
};

function createAcsEventsStore() {
    const acsEventsStore = writable(initialState);

    return {
        get() {
            return get(acsEventsStore);
        },
        set: acsEventsStore.set,
        subscribe: acsEventsStore.subscribe,
        reset() {
            acsEventsStore.set(initialState);
        },
        async loadAcsEvents(assessmentId, options = {}) {
            const currentState = get(acsEventsStore);
            const pageSize = currentState.pageSize || DEFAULT_PAGE_SIZE;
            const pageNum = options.pageNum ?? currentState.pageNum;
            const sortOrder = options.sortOrder ?? currentState.sortOrder;

            acsEventsStore.set({
                items: [],
                totalResults: 0,
                lastId: [],
                pageSize,
                pageNum,
                sortOrder,
                isLoading: true,
                error: null,
                hasLoaded: false
            });

            try {
                const {
                    data = [],
                    totalResults = 0,
                    lastId = []
                } = await getAcsEvents(assessmentId, {
                    pageSize,
                    pageNum,
                    sortOrder
                });

                acsEventsStore.set({
                    items: data,
                    totalResults,
                    lastId,
                    pageSize,
                    pageNum,
                    sortOrder,
                    isLoading: false,
                    error: null,
                    hasLoaded: true
                });
            } catch (error) {
                acsEventsStore.set({
                    items: [],
                    totalResults: 0,
                    lastId: [],
                    pageSize,
                    pageNum,
                    sortOrder,
                    isLoading: false,
                    error,
                    hasLoaded: true
                });
            }
        }
    };
}

export const acsEventsStore = createAcsEventsStore();
